module.exports = __webpack_public_path__ + "img/bg_in.595fc887.jpg";